import { filterCompanies } from 'common/api/companies';

import {
    FETCH_COMPANIES,
    FETCH_COMPANIES_FAILURE,
    FETCH_COMPANIES_SUCCESS,
} from '../actionTypes';
import { companiesActions } from '../reducer';

export default (filterData) => (dispatch) => {
    dispatch(companiesActions[FETCH_COMPANIES]());

    const {
        countryName,
        orderBy,
        page = 0,
        pageSize,
        planName,
        searchText,
        sortBy,
        status,
    } = filterData;

    filterCompanies({
        countryName: countryName,
        orderBy,
        page: page + 1,
        perPage: pageSize,
        planName: planName,
        searchText,
        sortBy,
        status,
    })
        .then((response) =>
            dispatch(companiesActions[FETCH_COMPANIES_SUCCESS](response.data)),
        )
        .catch((error) =>
            dispatch(
                companiesActions[FETCH_COMPANIES_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
